// extracted by mini-css-extract-plugin
export default {"root":"Tabs_root__xJNwr","item":"Tabs_item__5+Mhm","active":"Tabs_active__W36eR"};